import type { ImproveMpPerformanceTier3Assignment } from '@typings/experiments';
import type { State } from 'types/redux';
import { selectAssignment } from '.';

const CONTROL = 'control';
const VARIANT = 'variant1';

// A bare `?gatekeeper=improveMpPerformanceTier3` flag resolves to boolean `true`
// rather than a variant string, so this can't be a blind cast (GS-1394).
export const improveMpPerformanceTier3Selector = (
	state: State,
): ImproveMpPerformanceTier3Assignment => {
	const assignment = selectAssignment(state, ['improveMpPerformanceTier3']);
	return assignment === CONTROL || assignment === VARIANT ? assignment : null;
};
